import axios from 'axios'

class LicitacaoApiClient {
    
    async buscarEstados() {
        return axios.get('/efornecedor/hal/public/localizacoes/estados')
    }

}

export default new LicitacaoApiClient()
